/*
 * 认证模块
 */
export function login() {
  return {
    url: 'login',
    method: 'post',
    data: function ({ data }) {
      return _.get(data, 'account') == 'admin' && _.get(data, 'password') == '1234qwer'
        ? { 'code': 200, 'data': 'test', 'msg': '票据信息' }
        : { 'code': 401, 'data': 'null', 'msg': '用户认证失败，请检查用户名和密码' }
    }
  }
}

// 用户登出
export function logout() {
  return {
    url: 'logout',
    method: 'get',
    data: {
      'code': 200
    }
  }
}

// 认证信息
export function authenticated() {
  return {
    url: 'authc/authenticated',
    method: 'get',
    data: {
      'code': 200,
      'data': {
        'depId': null,
        'loginName': 'admin',
        'menus': [
          { 'menuId': 10000, 'pmenuId': null, 'menuType': 1, 'menuName': '业务域', 'menuIcon': 'fa fa-plus-square-o', 'menuTarget': '' },
          { 'menuId': 11000, 'pmenuId': 10000, 'menuType': 1, 'menuName': '居民信息', 'menuIcon': 'fa fa-plus-square-o', 'menuTarget': '' },
          { 'menuId': 11001, 'pmenuId': 11000, 'menuType': 1, 'menuName': '个人基本健康信息登记', 'menuIcon': '', 'menuTarget': 'personnelInfo/BasicInfoList' },
          { 'menuId': 11002, 'pmenuId': 11000, 'menuType': 1, 'menuName': '死亡医学证明', 'menuIcon': '', 'menuTarget': 'database/DataBase' },
          { 'menuId': 12000, 'pmenuId': 10000, 'menuType': 1, 'menuName': '儿童保健', 'menuIcon': 'fa fa-cogs', 'menuTarget': '' },
          { 'menuId': 12001, 'pmenuId': 12000, 'menuType': 1, 'menuName': '出生医学证明', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 12002, 'pmenuId': 12000, 'menuType': 1, 'menuName': '新生儿家庭访视', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 12003, 'pmenuId': 12000, 'menuType': 1, 'menuName': '儿童健康体检', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 13000, 'pmenuId': 10000, 'menuType': 1, 'menuName': '妇女保健', 'menuIcon': 'fa fa-cogs', 'menuTarget': '' },
          { 'menuId': 13001, 'pmenuId': 13000, 'menuType': 1, 'menuName': '首次产前随访服务', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 13002, 'pmenuId': 13000, 'menuType': 1, 'menuName': '产前随访服务', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 13003, 'pmenuId': 13000, 'menuType': 1, 'menuName': '产后访视', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 13004, 'pmenuId': 13000, 'menuType': 1, 'menuName': '产后42天健康检查', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 14000, 'pmenuId': 10000, 'menuType': 1, 'menuName': '疾病控制', 'menuIcon': 'fa fa-cogs', 'menuTarget': '' },
          { 'menuId': 14001, 'pmenuId': 14000, 'menuType': 1, 'menuName': '预防接种报告', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 14002, 'pmenuId': 14000, 'menuType': 1, 'menuName': '传染病报告', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 14003, 'pmenuId': 14000, 'menuType': 1, 'menuName': '死亡医学证明', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 15000, 'pmenuId': 10000, 'menuType': 1, 'menuName': '疾病管理', 'menuIcon': 'fa fa-cogs', 'menuTarget': '' },
          { 'menuId': 15001, 'pmenuId': 15000, 'menuType': 1, 'menuName': '高血压患者随访服务', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 15002, 'pmenuId': 15000, 'menuType': 1, 'menuName': '2型糖尿病患者随访服务', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 15003, 'pmenuId': 15000, 'menuType': 1, 'menuName': '重性精神疾病患者个人信息登记', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 15004, 'pmenuId': 15000, 'menuType': 1, 'menuName': '重性精神病患者随访服务', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 16000, 'pmenuId': 10000, 'menuType': 1, 'menuName': '医疗服务', 'menuIcon': 'fa fa-cogs', 'menuTarget': '' },
          { 'menuId': 16001, 'pmenuId': 16000, 'menuType': 1, 'menuName': '成人健康体检', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 16002, 'pmenuId': 16000, 'menuType': 1, 'menuName': '门诊摘要', 'menuIcon': '', 'menuTarget': 'medicalService/OutSummaryList' },
          { 'menuId': 16003, 'pmenuId': 16000, 'menuType': 1, 'menuName': '住院摘要', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 16004, 'pmenuId': 16000, 'menuType': 1, 'menuName': '会诊记录', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 16005, 'pmenuId': 16000, 'menuType': 1, 'menuName': '转诊（院）记录', 'menuIcon': '', 'menuTarget': '' },
          { 'menuId': 20000, 'pmenuId': null, 'menuType': 1, 'menuName': '共享文档', 'menuIcon': 'fa fa-plus-square-o', 'menuTarget': '' },
          { 'menuId': 21000, 'pmenuId': 20000, 'menuType': 1, 'menuName': '文档模板', 'menuIcon': '', 'menuTarget': 'fileManager/Template' },
          { 'menuId': 22000, 'pmenuId': 20000, 'menuType': 1, 'menuName': '业务域管理', 'menuIcon': '', 'menuTarget': 'fileManager/nodeConfig' },
          { 'menuId': 23000, 'pmenuId': 20000, 'menuType': 1, 'menuName': '数据标准字典', 'menuIcon': '', 'menuTarget': 'fileManager/nodeConfig' }

        ],
        'orgId': 1,
        'realName': '超级管理员',
        'roles': [
          'Admin'
        ],
        'telphone': '',
        'userId': -1
      },
      'msg': '用户信息'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mock/modules/authc.js